import type { BotaoIndicadoresProps } from "./types-botao-indicadores";
import { BotaoIndicadoresView } from "./view-botao-indicadores";

export function BotaoIndicadores(props: BotaoIndicadoresProps) {
  return <BotaoIndicadoresView {...props} />;
}

export type * from "./types-botao-indicadores";
